export enum CheckLayoutEnum {
	Top = 1,
	Middle = 2,
	Bottom = 3,
	Preprinted = 4,
	Mailer = 5,
}

export enum CheckLayoutDescEnum {
	Top = 'Top',
	Middle = 'Middle',
	Bottom = 'Bottom',
	Preprinted = 'Pre-printed',
	Mailer = 'Mailer',
}
